import { render, staticRenderFns } from "./VModalConfirmation.vue?vue&type=template&id=3dedf546&scoped=true&"
import script from "./VModalConfirmation.vue?vue&type=script&lang=ts&"
export * from "./VModalConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./VModalConfirmation.vue?vue&type=style&index=0&id=3dedf546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dedf546",
  null
  
)

export default component.exports